module.exports = __webpack_public_path__ + "static/img/icon_fcds.308b444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_fcds.png
// module id = wvK5
// module chunks = 0